import { render, staticRenderFns } from "./StandardNavigation.vue?vue&type=template&id=5fb2bce2&scoped=true&"
import script from "./StandardNavigation.vue?vue&type=script&lang=js&"
export * from "./StandardNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StandardNavigation.vue?vue&type=style&index=0&id=5fb2bce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2bce2",
  null
  
)

export default component.exports